<template>
  <div>
    <div v-if="imageUrls">
      <div v-for="(images,i) in date_images" v-bind:key="images + i" class="mr-2">
          <div class="my-3"><em>{{images.date}}</em></div>
          <div>
              <div v-for="(url,i) in images.urls" v-bind:key="url + i" class="image thumbnail">
                  <img :src="url">
                  <b-button class ="delete-button" variant="danger" @click="removeImage(url)">x</b-button>
              </div>
              
          </div>
      </div>
    </div>

    <b-spinner v-if="isLoading"></b-spinner>
    
    <div v-if="!isLoading">
      <b-form-file class="text-nowrap text-truncate"
          accept="image/*"
          multiple
          v-model="images"
          placeholder="Upload hình ảnh..."
      ></b-form-file>
      <b-button v-if="!isLoading" variant="success" class="my-3" @click="uploadImage()">
          Upload
      </b-button>
    </div>
  </div>
</template>

<script>

import Firebase from "../../services/firebase.js"

export default {
  name: 'ImagesFormField',
  data () {
    return {
      images: null,
      imageUrls: [],
      date_images: [],
      isLoading: false
    }
  },
  watch: {
    list_urls: function (newVal, oldVal) {
      if(newVal) {
        this.imageUrls = newVal;
        this.date_images = this.getDateImages(newVal);
      }
    }
  },
  methods: {
    async uploadImage() {
        if(!this.images)
            return;

        this.isLoading = true;

        var storage = Firebase.getStorage().ref().child(this.images_folder);

        var files = this.images;
        const timeElapsed = Date.now();
        const today = (new Date(timeElapsed)).toISOString().substr(0,10);
        return Promise.all(files.map(file => {
            const names = file.name.split('.');
            const fileName = names[0] + '-' + timeElapsed + '.' + names[1];
            return storage.child(fileName).put(file).then((snapshot) => {
                return snapshot.ref.getDownloadURL();
            }).then((url) => {
                this.imageUrls.push({url: url, file_name: fileName, time:today});
            }).catch((error) => {
                console.log('Upload image failed: ', error.message)
            });
        }))
        .then(() => {
            this.$emit('list_changed', this.imageUrls);
            this.images = null;
            this.isLoading = false;
        })
        .catch((error) => {
            console.log('error while uploading images', err);
            this.isLoading = false;
        });
    },

    async removeImage(url) {
      console.log('deleting img: ', url);

      for(var i=0; i<this.imageUrls.length; i++) {
        if(url === this.imageUrls[i].url){
          this.imageUrls.splice(i, 1);
          this.date_images = this.getDateImages(this.imageUrls);
          break;
        }
      }

      // // var filename = url.split('/')[0];
      // var storage = Firebase.getStorage();
      // var fileRef = storage.refFromURL(url);
      // console.log(fileRef);
      // // var desertRef = storageRef.child(filename);

      // try {
      //   await fileRef.delete();
      // } catch(err) {
      //   console.log(err);
      // }

      this.$emit('list_changed', this.imageUrls);
    },

    getDateImages(images) {
        let temp = [...images];
        let _date_images = [];

        temp.map((img) => {
            if (!_date_images[img.time]) {
                _date_images[img.time] = [];
            }

            _date_images[img.time].push(img.url);
        })

        let date_images = [];

        for (const time in _date_images) {
            date_images.push({date: time, urls: _date_images[time]});
        }

        date_images = date_images.sort((a,b) => b.date.localeCompare(a.date));

        return date_images;
    },
  },
  props: ['list_urls', 'images_folder'],
  mounted () {
      this.imageUrls = this.list_urls || [];

      this.date_images = this.getDateImages(this.imageUrls);
  }
}
</script>

<style scoped>
.image {
    display: inline-block;
    margin: 5px;
    cursor: pointer;
}

.center-cropped {
  object-position: center; /* Center the image within the element */
  height: 150px;
  width: 150px;
}

.thumbnail {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
}
.thumbnail img {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100%;
  width: auto;
  -webkit-transform: translate(-50%,-50%);
      -ms-transform: translate(-50%,-50%);
          transform: translate(-50%,-50%);
  transition: transform .2s;
}
.thumbnail img.portrait {
  width: 100%;
  height: auto;
}
.delete-button {
  position: absolute;
}
</style>
